const matchFilter = function (filterObj, value) {
	if (!filterObj.list || !filterObj.key || !value ) return false

	let filterGroup = filterObj.list.filter(f => f.filterOn == filterObj.key)
	let active = Object.keys(filterGroup).some(i => {
        if (filterGroup[i].id === value) {
            return true;
        }
    });

	return active
}

export default matchFilter